/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.RS = window.RS || {};

window.RS.Klaviyo = (function() {
  var subscribeUrl = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
  var RsKlaviyo = {};

  RsKlaviyo.globalNewsletterSubmitHandler = function globalNewsletterSubmitHandler(e, form) {
    e.preventDefault();

    if (form) {
      var formData = new FormData(form);
      var emailInputElem = form.querySelector('[name=email]');
      var errorElem = form.querySelector('.alert--error');

      if (emailInputElem) {
        fetch(subscribeUrl, {
          method: 'POST',
          body: formData
        })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response) {
            if (response.success){
              form.classList.add('newsletter__form--success');
              form.classList.remove('newsletter__form--error');
              
              if (emailInputElem) emailInputElem.value = '';

            } else {
              var msg = errorElem ? errorElem.dataset.msg :
              errorElem.innerHTML = msg;
              form.classList.add('newsletter__form--error');
            }
          }
        });
      } else {
        if (errorElem) {
          errorElem.innerHTML = 'E-mail required';
          form.classList.add('newsletter__form--error');
        }
      }
    }
  };

  RsKlaviyo.initGlobalNewsletter = function initGlobalNewsletter(selector) {

    if (selector) {
      document.addEventListener('DOMContentLoaded', function() {
        Array.from(document.querySelectorAll(selector)).forEach(function(newsletterForm) {
          if (newsletterForm) {
            newsletterForm.addEventListener('submit', function(e) {
              RsKlaviyo.globalNewsletterSubmitHandler(e, newsletterForm);
            });
          }
        });
      });
    }
  };

  return {
    initGlobalNewsletter: RsKlaviyo.initGlobalNewsletter,
    globalNewsletterSubmitHandler: RsKlaviyo.globalNewsletterSubmitHandler
  }
})();

// Initialize Klaviyo newsletter forms
window.RS.Klaviyo.initGlobalNewsletter('[data-klaviyo-newsletter]');